import { MY_GAMES_COUNTS, MY_GAMES_LOADED, MY_GAMES_LOADING } from "../actions/my-games";
import buildReducer from "./build-reducer";
import { fromJS, Map } from "immutable";

let reducers = {};

reducers[MY_GAMES_COUNTS] = (state, { counts }) =>
  state.set("counts", fromJS(counts));

reducers[MY_GAMES_LOADING] = (state) =>
  state.remove("ids")
    .set("loading", true);

reducers[MY_GAMES_LOADED] = (state, { ids }) =>
  state.remove("loading")
    .set("ids", fromJS(ids));

export default buildReducer(Map(), reducers);
